import { UPLOADS_ROUTES } from './constants';
import UploadsLayout from './components/UploadsLayout';

export default [
    {
        path: UPLOADS_ROUTES.LIST,
        component: UploadsLayout
    }
];
